export const getSetPriceAmount = (durationSeconds) => {
  const seconds = Number(durationSeconds);

  if (!Number.isFinite(seconds) || seconds < 60) {
    return null;
  }

  if (seconds <= 30 * 60) return 1.99;
  if (seconds <= 60 * 60) return 2.99;
  if (seconds <= 120 * 60) return 4.99;

  return 5.99;
};

export const validateVideoPriceAmount = (value, durationSeconds) => {
  const setPriceAmount = getSetPriceAmount(durationSeconds);

  if (setPriceAmount === null) {
    return {
      valid: false,
      priceAmount: null,
      setPriceAmount: null,
      message: "A valid video is required to calculate the rental price.",
    };
  }

  const input = String(value ?? "").trim();

  if (!/^\d+(?:\.\d{1,2})?$/.test(input)) {
    return {
      valid: false,
      priceAmount: null,
      setPriceAmount,
      message: "Enter a valid price with up to 2 decimal places.",
    };
  }

  const cents = Math.round(Number(input) * 100);
  const minimumCents = Math.round(setPriceAmount * 100);

  if (!Number.isSafeInteger(cents) || cents > 9999999999) {
    return {
      valid: false,
      priceAmount: null,
      setPriceAmount,
      message: "Enter a valid rental price.",
    };
  }

  if (cents < minimumCents) {
    return {
      valid: false,
      priceAmount: null,
      setPriceAmount,
      message: `The minimum rental price for this video is A$${setPriceAmount.toFixed(2)}.`,
    };
  }

  return {
    valid: true,
    priceAmount: cents / 100,
    setPriceAmount,
    message: "",
  };
};
